<template>
  <div>
    <div
      v-for="({ title, icon, description }, index) in profileCardItems"
      :key="index"
    >
      <div
        class="flex items-center box-border mb-4 lg:mb-10 bg-white w-full lg:max-w-[912px] lg:max-h-[112px] xl:max-w-[567px] xl:max-h-[120px] last:mb-0 p-4 lg:p-0 lg:px-8"
      >
        <div class="h-full">
          <div
            class="w-14 h-14 md:w-[72px] md:h-[72px] rounded-full flex items-center justify-center bg-purpleLightPrimary"
          >
            <BaseIcon
              :icon="icon"
              class="text-brandSecondary w-6 h-6 md:w-10 md:h-10 aspect-w-[1] aspect-h-[1] rounded-lg"
            />
          </div>
        </div>
        <div class="pl-4 lg:pl-8 lg:py-7 xl:py-5 flex-auto">
          <TypeHeading
            tag="p"
            variant="subtitle"
            weight="strong"
            class="text-body leading-6 text-grayHeader pb-2 lg:text-18 text-purpleLinkSmall"
          >
            {{ title }}
          </TypeHeading>
          <TypeBody
            tag="p"
            variant="text"
            class="text-grayBody text-medium leading-5 lg:leading-6"
          >
            <span v-html="description" class="richText" />
          </TypeBody>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { TypeBody, TypeHeading, BaseIcon } from '@bambeehr/pollen';

export default defineComponent({
  name: 'ProfileCard',
  components: {
    TypeBody,
    TypeHeading,
    BaseIcon,
  },
  props: {
    profileCardItems: {
      type: [],
    },
  },
});
</script>
